export default {"src":"/_next/static/media/sliderHandleMobile.3c93725d.svg","height":152,"width":28};